import { render } from "./SectionHome.vue?vue&type=template&id=31388ca1&scoped=true"
import script from "./SectionHome.vue?vue&type=script&lang=js"
export * from "./SectionHome.vue?vue&type=script&lang=js"

import "./SectionHome.vue?vue&type=style&index=0&id=31388ca1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31388ca1"]])

export default __exports__